import React from "react";
import Header from "../../sections/Header/Header";
import Footer from "../../sections/Footer/Footer";

const Page404: React.FC = () => (
    <div className="wrapper">
        <Header />
        <main>
            <section className="page__404">
                <div className="section__wrapper">
                    <div className="page__404__work">
                        <div className="page__404__title">
                            <h3>Запрашиваемая страница не найдена!</h3>
                            <p>Такой страницы не существует или она была удалена.</p>
                        </div>
                        <div className="page__404__img">
                            <span>404</span>
                            <svg width="186" height="179" viewBox="0 0 186 179" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M134.678 89.3849C135.452 88.1338 135.443 86.551 134.656 85.3084L82.395 2.78682C81.6904 1.67429 80.4653 0.999995 79.1484 0.999995H56.7941C55.4772 0.999995 54.2521 1.67428 53.5475 2.78682L1.28639 85.3084C0.49946 86.551 0.490786 88.1338 1.26405 89.3849L55.0632 176.431C55.7634 177.564 57.0002 178.254 58.3321 178.254H77.6104C78.9423 178.254 80.1791 177.564 80.8794 176.431L134.678 89.3849Z"
                                    fill="#F2F2F5" />
                                <path
                                    d="M184.678 89.3849C185.452 88.1338 185.443 86.551 184.656 85.3084L132.395 2.78682C131.69 1.67429 130.465 0.999995 129.148 0.999995H106.794C105.477 0.999995 104.252 1.67428 103.548 2.78682L51.2864 85.3084C50.4995 86.551 50.4908 88.1338 51.264 89.3849L105.063 176.431C105.763 177.564 107 178.254 108.332 178.254H127.61C128.942 178.254 130.179 177.564 130.879 176.431L184.678 89.3849Z"
                                    stroke="black" strokeMiterlimit="10" />
                            </svg>
                        </div>
                        <a href="/">Вернуться на главную</a>
                    </div>
                </div>
            </section>
        </main>
        <Footer />
    </div>
);

export default Page404;